// ScrollRestoration.tsx
import { useEffect, useRef } from "react"
import { useLocation, useNavigationType } from "react-router"

const scrollMap = new Map<string, number>()

export default function ScrollRestoration() {
  const location = useLocation()
  const navType = useNavigationType()
  const pathnameRef = useRef(location.pathname)

  useEffect(() => {
    // 离开页面时，记录滚动位置
    return () => {
      scrollMap.set(pathnameRef.current, window.scrollY)
    }
  }, [])

  useEffect(() => {
    const key = location.pathname
    pathnameRef.current = key
    if (location.state && (location.state as any).scrollTo) {
      return
    }
    // 返回（POP）才恢复滚动
    if (navType === "POP" && scrollMap.has(key)) {
      requestAnimationFrame(() => {
        window.scrollTo(0, scrollMap.get(key)!)
      })
    } else {
      // 新页面，滚到顶部
      //window.scrollTo(0, 0)
    }
  }, [navType])

  return null
}
